import store from '../redux/store/store';

const getCategoryById = (id) => {
	const { categories } = store.getState().dashboard;

	return categories && categories.get(id);
};
export default getCategoryById;